import React, { useEffect, useState } from 'react';
import { PlusIcon, CreditCardIcon, DollarSignIcon, TrendingUpIcon, ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
import { AddFundsModal } from './AddFundsModal';
import { AddFundsBottomSheet } from './AddFundsBottomSheet';
export function WalletSection() {
  const [showAddFunds, setShowAddFunds] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 768);
  const walletBalance = 450.75;
  const transactions = [{
    id: 1,
    type: 'credit',
    description: 'Added funds',
    amount: 200.0,
    date: '2024-01-15',
    status: 'completed'
  }, {
    id: 2,
    type: 'debit',
    description: 'Order #000013951',
    amount: -25.98,
    date: '2024-01-15',
    status: 'completed'
  }, {
    id: 3,
    type: 'debit',
    description: 'Order #000013950',
    amount: -24.99,
    date: '2024-01-10',
    status: 'completed'
  }, {
    id: 4,
    type: 'credit',
    description: 'Refund - Order #000013945',
    amount: 89.5,
    date: '2024-01-08',
    status: 'completed'
  }];
  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleAddFunds = (amount: number, paymentMethod: string) => {
    console.log('Adding funds:', amount, paymentMethod);
    // Handle payment processing here
    setShowAddFunds(false);
  };
  return <div className="space-y-6" data-id="element-1066" data-mp="3j3omud9faot3">
      {/* Wallet Balance Card */}
      <div className="bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] rounded-xl shadow-lg p-6 text-white" data-id="element-1067" data-mp="3o06kyua8zowg">
        <div className="flex items-center justify-between mb-4" data-id="element-1068" data-mp="3a28d87qfmqpx">
          <div className="flex items-center gap-2" data-id="element-1069" data-mp="3f00f9uksjt7u">
            <DollarSignIcon className="w-6 h-6" data-id="element-1070" data-mp="3ezqpa6zqxm25" />
            <h2 className="text-lg font-bold" data-id="element-1071" data-mp="1kjrzaq3dey1x">Wallet Balance</h2>
          </div>
          <TrendingUpIcon className="w-5 h-5 text-green-300" data-id="element-1072" data-mp="1klw7hk8ayj80" />
        </div>
        <div className="mb-6" data-id="element-1073" data-mp="1fs0hb3ya60ne">
          <p className="text-sm text-blue-200 mb-1" data-id="element-1074" data-mp="1au8g1jbqx26j">Available Balance</p>
          <p className="text-4xl font-bold" data-id="element-1075" data-mp="1as5q0zalf91t">SAR {walletBalance.toFixed(2)}</p>
        </div>
        <button onClick={() => setShowAddFunds(true)} className="w-full flex items-center justify-center gap-2 bg-white text-[#1E2B55] font-medium py-3 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1076" data-mp="16uhpngq4so2j">
          <PlusIcon className="w-5 h-5" data-id="element-1077" data-mp="1ui7o2mexdv89" />
          Add Funds
        </button>
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-2 gap-4" data-id="element-1078" data-mp="1pjo0khkoobds">
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5" data-id="element-1079" data-mp="1piv2s63pcw7s">
          <div className="flex items-center gap-2 mb-2" data-id="element-1080" data-mp="j3u43snalzxi">
            <ArrowUpIcon className="w-4 h-4 text-green-600" data-id="element-1081" data-mp="e493ldsh5jio" />
            <span className="text-sm text-gray-600" data-id="element-1082" data-mp="e2odq1h3uor5">Total Added</span>
          </div>
          <p className="text-2xl font-bold text-gray-900" data-id="element-1083" data-mp="2psw6ssdmlbi2">SAR 1,250.00</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5" data-id="element-1084" data-mp="2ur7eawgg79x4">
          <div className="flex items-center gap-2 mb-2" data-id="element-1085" data-mp="2yrr8ps9mzzfk">
            <ArrowDownIcon className="w-4 h-4 text-red-600" data-id="element-1086" data-mp="2yq6fq72z0ojt" />
            <span className="text-sm text-gray-600" data-id="element-1087" data-mp="33jj1m9g9mh8v">Total Spent</span>
          </div>
          <p className="text-2xl font-bold text-gray-900" data-id="element-1088" data-mp="38grdxteqfr27">SAR 799.25</p>
        </div>
      </div>
      {/* Transaction History */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1089" data-mp="3df2o658xw3ky">
        <div className="p-5 border-b border-gray-200" data-id="element-1090" data-mp="3ihbgczdzn1m0">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1091" data-mp="3mhbwcogqjkv6">
            Transaction History
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-1092" data-mp="1o2r2b5k6a4bl">
          {transactions.map(transaction => <div key={transaction.id} className="p-5 hover:bg-gray-50 transition-colors" data-id="element-1093" data-mp="1s2su8n03vjdo">
              <div className="flex items-center justify-between" data-id="element-1094" data-mp="wrta1uadhlzg">
                <div className="flex items-center gap-3" data-id="element-1095" data-mp="sskeqkzopg1s">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${transaction.type === 'credit' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-1096" data-mp="su59obpwv106">
                    {transaction.type === 'credit' ? <ArrowUpIcon className="w-5 h-5 text-green-600" data-id="element-1097" data-mp="e3oakz0r0n6g" /> : <ArrowDownIcon className="w-5 h-5 text-red-600" data-id="element-1098" data-mp="954ngvaf55ci" />}
                  </div>
                  <div data-id="element-1099" data-mp="nuanumkzt1lz">
                    <p className="font-medium text-gray-900" data-id="element-1100" data-mp="nuizyc9ak2w4">
                      {transaction.description}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1101" data-mp="3rh9lqfn3zyve">{transaction.date}</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-1102" data-mp="3mhww5n4usdp4">
                  <p className={`font-bold ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1103" data-mp="220nqs6rrdo8u">
                    {transaction.type === 'credit' ? '+' : ''}SAR{' '}
                    {Math.abs(transaction.amount).toFixed(2)}
                  </p>
                  <span className="inline-block px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded-full" data-id="element-1104" data-mp="1x1b53pcmin7u">
                    Completed
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* Add Funds Modal for Desktop */}
      {!isMobile && <AddFundsModal isOpen={showAddFunds} onClose={() => setShowAddFunds(false)} onConfirm={handleAddFunds} data-id="element-1105" data-mp="2bpfgs9d9dyh4" />}
      {/* Add Funds Bottom Sheet for Mobile */}
      {isMobile && <AddFundsBottomSheet isOpen={showAddFunds} onClose={() => setShowAddFunds(false)} onConfirm={handleAddFunds} data-id="element-1106" data-mp="10a0kz8wsdcnl" />}
    </div>;
}